// extracted by mini-css-extract-plugin
export default {"container":"HealthAndSafetyPolicyAtWorkPage_container__viZtj"};